<!-- Actions button bar -->
<div class="action-bar mat-elevation-z2">
	<mat-toolbar>
		@if(checkValidity('SEND_TO_CLIENTS')) {
		<button mat-raised-button color="primary" class="me-3 x-small-button" aria-label="Sent report" (click)="itemAction('SEND_TO_CLIENTS')">
			{{ 'BUTTON.SEND' | translate }}
		</button>
		}

    @if(checkValidity('ADD_TAGS')) {
      <button mat-raised-button color="primary" class="me-3 x-small-button" aria-label="Add tags" (click)="itemAction('ADD_TAGS')">
        {{ 'CLIPS.ADD_TAGS' | translate }}
      </button>
      }

      @if(checkValidity('COPY_TAGS')) {
        <button mat-raised-button color="primary" class="me-3 x-small-button" aria-label="Copy tags" (click)="itemAction('COPY_TAGS')">
          {{ 'CLIPS.COPY_TAGS' | translate }}
        </button>
        }

      @if(checkValidity('COPY')) {
        <button mat-raised-button color="primary" class="me-3 x-small-button" aria-label="Copy" (click)="itemAction('COPY')">
          {{ 'BUTTON.COPY' | translate }}
        </button>
        }

    @if(checkValidity('DELETE')) {
		<button mat-raised-button color="warn" class="me-3 x-small-button" aria-label="Delete contract notices" (click)="itemAction('DELETE')">
			{{ 'BUTTON.DELETE' | translate }}
		</button>
		}

    @if(autotagUiEnabled && dataAdministrationType === 'CONTRACT_NOTICES') {
		<button mat-raised-button color="accent" class="me-3 x-small-button" aria-label="Review bulk" (click)="itemAction('REVIEW_BULK')">
			{{ 'CONTRACT_NOTICES.REVIEW_BULK_BUTTON' | translate }}
		</button>
		}

    <div class="ms-auto d-flex me-2 align-items-center">
			@if(selectedItems.length) {
			<button mat-icon-button color="primary" class="unselect-button me-1" 
					matTooltip="{{ 'ASSORTED.UNSELECT_ALL' | translate }}"
					matTooltipPosition="below"
					aria-label="Unselect all" 
					(click)="itemAction('UNSELECT_ALL')">
				<mat-icon>close</mat-icon>
			</button>
			<span class="info-selected"> {{ 'ASSORTED.SELECTED' | translate }}: {{ selectedItems.length }} \</span>
			}
			<span class="info-selected ms-1">{{ 'ASSORTED.TOTAL' | translate }}: {{ totalItemsCount }}</span>
		</div>

    @if(scrollToTop) {
      <button mat-icon-button color="primary" class="x-small-button" aria-label="Scroll to top" (click)="itemAction('SCROLL_TO_TOP')">
        <mat-icon>arrow_upward_alt</mat-icon>
      </button>
      }
	</mat-toolbar>
	<mat-divider></mat-divider>
</div>
<!-- (END) Actions button bar -->
